import { useGetAgentMutationReports } from 'api-hooks/report';
import useDefaultValuesReportDate from 'hooks/use-default-values-report-date';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { NavigationProps } from 'types';

import PivotReportTemplate from './components/pivot-report-template';

export type AgentMutationReportParams = {
  filter: {
    agent: string;
  };
};

export default function AgentMutationReport(props: NavigationProps) {
  const { t } = useTranslation();
  const { query } = useRouter();

  const defaultFilters = useDefaultValuesReportDate('transaction');

  return (
    <PivotReportTemplate
      title={t('common:agent_mutation_report')}
      usePivotQuery={useGetAgentMutationReports}
      defaultFilters={[
        {
          name: 'agent',
          value: query['filter[agent]'] as string,
        },
        ...defaultFilters,
      ]}
      isShowAllFilterCompleted
    />
  );
}
